<template>
  <div class="bill-wrapper">

    <bill-filter-form
      v-if="hasRes('bill_index')"
      @filter="updateTableData" />

    <bill-statistic
      v-if="hasRes('bill_index')" />

    <!--表格-->
    <custom-table
      :data="orderList"
      size="mini"
      v-if="hasRes('bill_index')"
      :fetch="false"
      @data-change="updateTableData" >

      <el-table-column
        prop="order_no"
        label="订单号"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div slot="content">
              易售云单号: {{ scope.row.order_no }}<br/>
              商户单号: {{ scope.row.unique_id }}<br/>
              第三方单号: {{ scope.row.out_trade_no }}
            </div>
            <span>
              {{ scope.row.order_no }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
        prop="sn"
        label="设备号"
        sortable="custom"
        align="center"
        header-align="center" >
      </el-table-column>

      <el-table-column
        prop="client"
        label="支付方式"
        sortable="custom"
        align="center"
        header-align="center" >
      </el-table-column>

      <el-table-column
        prop="cardno"
        label="用户卡号"
        sortable="custom"
        align="center"
        header-align="center" >
      </el-table-column>

      <el-table-column
        prop="status"
        label="交易状态"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          <el-tag type="info" size="mini" v-if="scope.row.status === 0">未支付</el-tag>
          <el-tag type="success" size="mini" v-if="scope.row.status === 3 && scope.row.refund === 0">出货成功</el-tag>
          <el-tag type="info" size="mini" v-if="scope.row.status === 3 && scope.row.refund === 1">退款中</el-tag>
          <el-tag type="info" size="mini" v-if="scope.row.status === 3 && scope.row.refund === 2">退款成功</el-tag>
          <el-tag type="danger" size="mini" v-if="scope.row.status === 4">出货失败</el-tag>
          <el-tag type="danger" size="mini" v-if="scope.row.status === 1 || scope.row.status === 2 || scope.row.status === 5">异常</el-tag>
          <el-tag type="success" size="mini" v-if="scope.row.status === 6">游戏成功</el-tag>
          <el-tag type="success" size="mini" v-if="scope.row.status === 7">游戏失败</el-tag>
          <el-tag type="info" size="mini" v-if="scope.row.status === 8">自动退款</el-tag>
          <el-tag type="info" size="mini" v-if="scope.row.status === 9">手动退款</el-tag>
          <el-tag type="info" size="mini" v-if="scope.row.status === 10 || scope.row.status === 11">部分退款</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="total_price"
        label="交易金额"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          <span>{{(scope.row.total_price / 100).toFixed(2)}} 元</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="bank_no"
        label="收款账户"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          {{ scope.row.bank_no || '未设置' }}
        </template>
      </el-table-column>

      <el-table-column
        prop="pay_channel"
        label="支付渠道"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          {{ scope.row.pay_channel in payChannelEnum ? payChannelEnum[scope.row.pay_channel] : '未知' }}
        </template>
      </el-table-column>

      <el-table-column
        prop="user"
        label="商户"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div slot="content">
              商户ID: {{ scope.row.users[0].userid }} <br/>
              商户昵称: {{ scope.row.users[0].alias }} <br/>
              代理商ID: {{ scope.row.agents[0].agentid }} <br/>
              代理商: {{ scope.row.agents[0].agentname }} <br/>
              代理商昵称：{{ scope.row.agents[0].nickname }}
            </div>
            <span>{{ scope.row.users[0].username }}</span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
        prop="area"
        label="区域/门店"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div slot="content">
              区域：{{ scope.row.area }} <br/>
              门店：{{ scope.row.store }}
            </div>
            <span>
              {{ `${scope.row.areas && scope.row.areas.length > 0 ?
              scope.row.areas[0].area_name : '未设置'}/${
              scope.row.stores && scope.row.stores.length > 0 ?
              scope.row.stores[0].store_name : '未设置'}` }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
        prop="goods"
        label="购买商品"
        sortable="custom"
        align="center"
        header-align="center" >

        <template slot-scope="scope">
          <span class="goods-title" v-if="scope.row.goods.length > 0">{{scope.row.goods[0].title}} x {{scope.row.goods[0].count}}<span v-if="scope.row.goods.length > 1">..</span> </span>
          <br>
          <el-popover
            placement="top"
            width="600">
            <el-table
              :data="scope.row.goods"
              size="small"
              :row-style="tableRowStyle" >
              <el-table-column property="title" label="购买商品" align="center" header-align="center"></el-table-column>
              <el-table-column property="channel_road" label="货架" :formatter="channelFormatter" align="center" header-align="center"></el-table-column>
              <el-table-column label="购买成功个数" align="center" header-align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.count - scope.row.fail_count}}</span>
                </template>
              </el-table-column>
              <el-table-column property="fail_count" label="购买失败个数" align="center" header-align="center"></el-table-column>
              <el-table-column property="price" label="订单金额" align="center" header-align="center">
                <template slot-scope="scope">
                  <span>{{(scope.row.price / 100).toFixed(2)}} 元</span>
                </template>
              </el-table-column>
              <el-table-column property="err" label="失败原因" :formatter="errorMsg" align="center" header-align="center"></el-table-column>
            </el-table>
            <span class="goods-title-more" slot="reference">订单详情</span>
          </el-popover>
        </template>
      </el-table-column>

      <el-table-column
        prop="create_at"
        label="交易时间"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div slot="content">
              最后更新时间：{{ scope.row.update_at | dateformat }}
            </div>
            <span>{{ scope.row.create_at | dateformat }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
    </custom-table>

    <custom-paginate
      :count="orderCount"
      v-if="hasRes('bill_index')"
      @page-change="updateTableData">
    </custom-paginate>
  </div>
</template>

<script>
import CustomTable from '@/components/CustomTable'
import CustomPaginate from '@/components/CustomPaginate'
import BillFilterForm from '@/components/bill/BillFilterForm'
import BillStatistic from '@/components/bill/BillStatistic'

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_LOADING } from '@/store/modules/table'

export default {
  name: 'Bill',
  components: {
    CustomTable,
    CustomPaginate,
    BillFilterForm,
    BillStatistic
  },
  data () {
    return {
      payChannelEnum: {
        'unknown': '未知',
        'sb': '扫呗',
        'jd': '京东',
        'qm': '钱喵'
      }
    }
  },
  computed: {
    ...mapState('table', [
      'page',
      'pageSize',
      'sort',
      'filters'
    ]),
    ...mapState('bill', [
      'orderList',
      'orderCount'
    ]),
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_LOADING
    ]),
    ...mapActions('bill', [
      'getOrders'
    ]),

    // 货架格式化
    channelFormatter (row) {
      return row.id || row.channel_road
    },
    // 格式化错误原因
    errorMsg (row) {
      const errorList = {
        0: '正常出货',
        1: '马达故障',
        2: '红外线故障',
        3: '主控应答超时',
        4: '确认出货超时',
        5: '网络中断',
        6: '过流',
        7: '欠流',
        8: '有反馈电磁门未开',
        9: '光幕自检失败，未启动电机',
        10: '货架被占用，无法出货'
      }
      if (errorList[row.err] === undefined) {
        return '未知错误'
      }
      return errorList[row.err]
    },
    tableRowStyle ({row, index}) {
      return {
        // background: '#232429'
      }
    },

    updateTableData () {
      if (!this.hasRes('bill_index')) return

      this.setLoading(true)

      this.getOrders({
        page: this.page,
        pageSize: this.pageSize,
        sort: this.sort,
        filters: this.filters
      }).then(res => {
        this.setLoading(false)
      }).catch(err => {
        console.log(err)

        this.setLoading(false)
        this.$message({
          type: 'error',
          message: '获取订单数据失败'
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/base";

.bill-wrapper {

  .goods-title-more {
    cursor: pointer;
    font-size: 10px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/Bill.vue